/* eslint-disable */
import {
  Flex,
  Input,
  Modal,
  Select,
  Tag,
  DatePicker,
  Space,
  Tooltip,
  Badge,
  Dropdown,
  List,
  Button,
  message,
  Radio,
  Spin
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
  useCallback,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import {
  FormOutlined,
  MenuOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  HistoryOutlined,
  ClusterOutlined,
  DotChartOutlined,
  BlockOutlined,
  FileTextOutlined,
  MailOutlined
} from "@ant-design/icons";
import { dataTo12Fn } from "@/utils/date.js";
import { useLocation } from "react-router-dom";
const { RangePicker } = DatePicker;
const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const isFirstRefresh = useRef(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [tableList, setTableList] = useState([]);
  const [clockListLoading, setClockListLoading] = useState(false);
  const [reviewMaterialsLoading, setReviewMaterialsLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [columns, setColumns] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const initTableHead = {
    status: null,
    prop: null,
    workType: null,
    propUnit: null,
    address: null,
    city: null,
    job: null,
    remark: null,
    requestBy: null,
    createByName: null,
    requestNo: null,
    vendorName: null,
    sCreateTime: null,
    sCompletionDate: null,
    eCreateTime: null,
    eCompletionDate: null,
    requestByName: null,
    ids: null,
    groupSupervisor: null,
    type: null,
    isMaterials: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);
  const [reviewMaterialsModal, setReviewMaterialsModal] = useState(false);
  const [reviewMaterialsList, setReviewMaterialsList] = useState([]);
  const [approvalState, setApprovalState] = useState({
    id: null,
    reviewStatus: "2",
    rejectReason: "",
  });
  const [approvalModal, setApprovalModal] = useState(false);
  const [clockList, setClockList] = useState([]);
  const [closkModal, setCloskModal] = useState(false);
  const initialLoad = useRef(false);
  const [pickerDates, setPickerDates] = useState(null);
  const [PredictedDates, setPredictedDates] = useState(null);

  // 映射表单 ，转化配置
  const fieldMap = {
    jobs: "job", // jobs -> job
  };
  const handleOk = (dates, confirm, startKey, endKey) => {
    if (dates && dates.length === 2) {
      const startDate = dates[0].format("MM/DD/YYYY");
      const endDate = dates[1].format("MM/DD/YYYY");
      const startTime = dates[0].valueOf();
      const endTime = dates[1].valueOf();

      handleApiCall(
        startDate,
        endDate,
        startTime,
        endTime,
        confirm,
        startKey,
        endKey,
      );
    } else {
      return;
    }
  };

  // 通用的 API 调用
  const handleApiCall = async (
    startDate,
    endDate,
    startTime,
    endTime,
    confirm,
    startKey,
    endKey,
  ) => {
    console.log("Fetching data for:", startDate, endDate);
    setTableHead((prev) => {
      const updatedTableHead = {
        ...prev,
        [startKey]: startTime,
        [endKey]: endTime,
      };
      console.log("Updated tableHead:", updatedTableHead);
      getTableListFn(1, pagination.pageSize, updatedTableHead);
      return updatedTableHead;
    });
    if (confirm) {
      confirm(); //  关闭下拉
    }
  };
  // 通用 Reset
  const handleReset = (setDates, startKey, endKey, clearFilters) => {
    clearFilters?.();
    setDates([]);
    setTableHead((prev) => {
      const updatedTableHead = {
        ...prev,
        [startKey]: "",
        [endKey]: "",
      };
      getTableListFn(1, pagination.pageSize, updatedTableHead);
      return updatedTableHead;
    });
  };

  const handlePressEnterRequestBy = (value) => {
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, requestBy: value };
      getTableListFn(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };

  const statusChange = (value) => {
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, status: value };
      getTableListFn(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };
  const statusChangeWork = (value) => {
    console.log(`selected ${value}`);
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, workType: value };
      getTableListFn(1, 25, updatedTableHead);
      return updatedTableHead;
    });
    console.log(tableHead);
  };
  const statusChangeMateria = (value) => {
    console.log(`selected ${value}`);
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, isMaterials: value };
      getTableListFn(1, 25, updatedTableHead);
      return updatedTableHead;
    });
    console.log(tableHead);
  };

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  // 定义列，包括输入框
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "index",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) =>
        ((commonFn.btnAuthorityFlag("ReviewMaterials") ||
          commonFn.btnAuthorityFlag("InvoiceJobHistory") ||
          commonFn.btnAuthorityFlag("LinkProp") ||
          commonFn.btnAuthorityFlag("LinkProp-Unit") ||
          commonFn.btnAuthorityFlag("LinkProp-Unit-Tenant")) && (
          <Badge count={record.messageCount} offset={[6, -6]} size={"small"}>
            <Dropdown
              menu={{
                items: [
                  commonFn.btnAuthorityFlag("ReviewMaterials") && {
                    key: "ReviewMaterials",
                    icon: (
                      <EditOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Review Materials",
                  },
                  commonFn.btnAuthorityFlag("InvoiceJobHistory") && {
                    key: "InvoiceJobHistory",
                    icon: (
                      <HistoryOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Invoice Job History",
                  },
                  commonFn.btnAuthorityFlag("LinkProp") && {
                    key: "Prop",
                    icon: (
                      <ClusterOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Link Prop",
                  },
                  commonFn.btnAuthorityFlag("LinkProp-Unit") && {
                    key: "Unit",
                    icon: (
                      <DotChartOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Link Prop-Unit",
                  },
                  commonFn.btnAuthorityFlag("LinkProp-Unit-Tenant") && {
                    key: "Tenant",
                    icon: (
                      <BlockOutlined
                        style={{ color: "#00c0ef", fontSize: "17px" }}
                      />
                    ),
                    label: "Link Prop-Unit-Tenant",
                  },
                ],
                onClick: (e) => badgeFn(record, e),
              }}
              trigger={["click"]}
            >
              <MenuOutlined
                style={{
                  cursor: "pointer",
                  fontSize: "16px",
                  color: "#0e78a9",
                }}
              />
            </Dropdown>
          </Badge>
        )) ||
        null,
    },
    {
      title: "Request No",
      dataIndex: "requestNo",
      key: "requestNo",
      hidden: false,
      width: 110,
      align: "center",
      isSorter: true,
      sorter: true,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "requestNo"),
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Status</div>
          <div>
            <Select
              value={tableHead.status}
              defaultValue="All"
              placeholder="Select status"
              style={{ width: 100 }}
              onClick={(e) => e.stopPropagation()}
              onChange={statusChange}
              options={[
                {
                  value: "",
                  label: "All",
                },
                {
                  value: "Pending",
                  label: "Pending",
                },
                {
                  value: "Assigned",
                  label: "Assigned",
                },
                {
                  value: "Quoted",
                  label: "Quoted",
                },
                {
                  value: "Approved",
                  label: "Approved",
                },
                {
                  value: "Review",
                  label: "Review",
                },
              ]}
            />
          </div>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      align: "center",
      hidden: false,
      width: 110,
      className: "custom-sort-header",
      sorter: true,
      render: (text, record, index) => {
        let statusText = "";
        let tagColor = "";
        if (text == "Pending") {
          statusText = "Pending";
          tagColor = "#dd4b39";
        } else if (text == "Quoted") {
          statusText = "Quoted";
          tagColor = "#dd4b39";
        } else if (text == "Assigned") {
          statusText = "Assigned";
          tagColor = "#dd4b39";
        } else if (text == "Approved") {
          statusText = "Approved";
          tagColor = "#dd4b39";
        } else if (text == "Review") {
          statusText = "Review";
          tagColor = "#dd4b39";
        } else if (text == "Ready To Pay") {
          statusText = "Ready To Pay";
          tagColor = "#00a65a";
        } else if (text == "Document Only") {
          statusText = "Document Only";
          tagColor = "#3c8dbc";
        }

        return (
          <a onClick={(e) => showModalOpen(record)}>
            <Tag color={tagColor}>{statusText}</Tag>
          </a>
        );
      },
    },

    {
      title: "Created Time",
      dataIndex: "createTime",
      key: "createTime",
      width: 200,
      align: "center",
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={pickerDates}
            onChange={(dates) => {
              setPickerDates(dates);
              handleOk(dates, confirm, "sCreateTime", "eCreateTime");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setPickerDates,
                "sCreateTime",
                "eCreateTime",
                clearFilters,
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => moment(text).format("MM/DD/YYYY HH:mm"),
    },
    {
      title: "Invoice Count",
      dataIndex: "invoiceCount",
      key: "invoiceCount",
      hidden: false,
      width: 110,
      align: "center",
      isSorter: true,
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "invoiceCount"),
    },
    {
      title: "Job Type",
      dataIndex: "jobs",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobs"),
      render: (text, record, index) => {
        return (
          <Flex gap="4px 0" wrap>
            {record.jobs.map((item, idx) => (
              <Tooltip title={` ${item}`} classNames="my-tooltip">
                <Tag
                  color="blue"
                  key={idx}
                  style={{
                    // color: "#373D4E",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "remark"),
      render: (text, record, index) => (
        <Tooltip title={` ${text}`} classNames="my-tooltip">
          <div
            className="text-clamp"
            style={{ whiteSpace: "normal", width: "100px" }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Material</div>
          <div>
            <Select
              value={tableHead.isMaterials}
              defaultValue="All"
              placeholder="Select Material"
              style={{ width: 100 }}
              onClick={(e) => e.stopPropagation()}
              onChange={statusChangeMateria}
              options={[
                { value: "", label: "All" },
                { value: "1", label: "Yes" },
                { value: "2", label: "No" },
              ]}
            />
          </div>
        </div>
      ),
      dataIndex: "isMaterials",
      key: "isMaterials",
      align: "center",
      hidden: false,
      sorter: true,
      width: 110,
      sorter: (a, b) => {
        if (a.isMaterials == null && b.isMaterials == null) return 0;
        if (a.isMaterials == null) return 1;
        if (b.isMaterials == null) return -1;
        return a.isMaterials - b.isMaterials;
      },
      className: "custom-sort-header",
      render: (text, record, index) => {
        return text === null
          ? " "
          : text === 1
            ? "Yes"
            : text === 2
              ? "No"
              : " ";
      },
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Vendor Type</div>
          <div>
            <Select
              value={tableHead.workType}
              defaultValue="All"
              placeholder="Select status"
              style={{ width: 100 }}
              onClick={(e) => e.stopPropagation()}
              onChange={statusChangeWork}
              options={[
                { value: "", label: "All" },
                { value: "1", label: "Maint.Worker" },
                { value: "2", label: "Contractor" },
                { value: "3", label: "Gardener" },
              ]}
            />
          </div>
        </div>
      ),
      dataIndex: "workType",
      key: "workType",
      align: "center",
      hidden: false,
      sorter: true,
      width: 110,

      className: "custom-sort-header",
      render: (text, record, index) => {
        return text === null
          ? " "
          : text === 1
            ? "Maint.Worker"
            : text === 2
              ? "Contractor"
              : text === 3
                ? "Gardener"
                : " ";
      },
    },

    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },

    {
      title: "Predicted Date",
      dataIndex: "completionDate",
      key: "completionDate",
      width: 150,
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={PredictedDates}
            onChange={(dates) => {
              setPredictedDates(dates);
              handleOk(dates, confirm, "sCompletionDate", "eCompletionDate");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setPredictedDates,
                "sCompletionDate",
                "eCompletionDate",
                clearFilters,
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },
    {
      title: "Unit Address",
      dataIndex: "address",
      titleType: "Input",
      width: 150,
      isSorter: true,
      // sorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "address"),
    },

    {
      title: "City",
      dataIndex: "city",
      titleType: "Input",
      width: 100,
      isSorter: true,
      // sorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "city"),
    },
    {
      title: "Supervisor",
      dataIndex: "groupSupervisor",
      titleType: "Input",
      width: 150,
      isSorter: true,
      // sorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "groupSupervisor"),
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Requested By</div>
          <div>
            <Select
              value={tableHead.requestByName}
              defaultValue="All"
              placeholder="Select status"
              style={{
                width: 90,
              }}
              onClick={(e) => e.stopPropagation()}
              onChange={handlePressEnterRequestBy}
              options={[
                {
                  value: "",
                  label: "All",
                },
                {
                  value: "1",
                  label: "Tenant",
                },
                {
                  value: "2",
                  label: "Manager",
                },
              ]}
            />
          </div>
        </div>
      ),
      dataIndex: "requestByName",
      key: "requestByName",
      align: "center",
      hidden: false,
      width: 100,
      sorter: true,
      className: "custom-sort-header",
      render: (text, record, index) => text,
    },

    {
      title: "Create By",
      dataIndex: "createByName",
      titleType: "Input",
      width: 100,
      isSorter: true,
      // sorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "createByName"),
    },
  ];

  const { confirm } = Modal;

  const badgeFn = (record, item) => {
    const fnMatch = {
      ReviewMaterials: reviewMaterialsModalFn,
      InvoiceJobHistory: invoiceJobHistoryFn,
      Prop: (record) => {
        console.log(record);
        showOpen({
          propId: record.propId,
          type: "Prop",
        });
      },

      Unit: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          type: "Unit",
        }),

      Tenant: (record) =>
        showOpen({
          propId: record.propId,
          unitId: record.unitId,
          tenantId: record.tenantId,
          type: "Tenant",
        }),
    };

    if (fnMatch[item.key]) {
      fnMatch[item.key](record);
    }
  };
  const invoiceJobHistoryFn = async ({ id }) => {
    setCloskModal(true);
    setClockListLoading(true);
    setClockList([]);
    try {
      const response = await http.get(
        `${api.getClockList}?maintenanceId=${id}`,
      );
      if (response.code === "1") {
        setClockList(response.data || []);
      } else {
        message.warning(response.msg || "Failed to load history.");
      }
    } catch (err) {
      message.error("Failed to load history.");
    } finally {
      setClockListLoading(false);
    }
  };

  const reviewMaterialsModalFn = async ({ id }) => {
    setReviewMaterialsModal(true);
    setReviewMaterialsLoading(true);
    setReviewMaterialsList([]);
    try {
      const response = await http.get(
        `${api.showMaterialsByMaintenanceId}?maintenanceId=${id}`,
      );
      if (response.code === "1") {
        setReviewMaterialsList(response.data || []);
      } else {
        message.warning(response.msg || "Failed to load materials.");
      }
    } catch (err) {
      message.error("Failed to load materials.");
    } finally {
      setReviewMaterialsLoading(false);
    }
  };

  const approvalFn = (item) => {
    setApprovalState({
      ...approvalState,
      id: item.id,
      maintenanceId: item.maintenanceId,
    });
    setApprovalModal(true);
  };

  const approvalSubmitFn = async () => {
    const response = await http.post(`${api.reviewMaterials}`, approvalState);
    if (response.code === "1") {
      reviewMaterialsModalFn({ id: approvalState.maintenanceId });
    } else {
      Modal.confirm({
        title: null,
        // icon: <ExclamationCircleOutlined />,
        content: response.msg,
        footer: null,
        closable: true,
        maskClosable: true,
      });
    }
    approvalModalCancel();
  };

  const approvalModalCancel = () => {
    setApprovalModal(false);
    setApprovalState({
      id: null,
      reviewStatus: "2",
      rejectReason: "",
    });
  };
  //复选框
  const rowSelection = {
    // 通过 getCheckboxProps 控制第一行不显示复选框
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, // 隐藏复选框
      disabled:
        record.status !== "Pending" ||
        (record.status === "Quoted" && materials_confirm_type === 2),
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      //选中
      console.log(selectedRowKeys);
      console.log(selectedRows);
      setSelectedList(selectedRows);
      props.deleteNum(selectedRows); //调用父组件方法
      //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
  };
  //列表
  const getTableListFn = async (page, pageSize, params = {}) => {
    try {
      console.log("Loading started");
      setTableLoading(true);

      const hash = window.location.hash;
      const queryStart = hash.indexOf("?");

      let ids = null;
      let statusFilterFromUrl = null;

      if (queryStart !== -1) {
        const queryString = hash.substring(queryStart + 1);
        const searchParams = new URLSearchParams(queryString);
        ids = searchParams.get("ids");
        statusFilterFromUrl = searchParams.get("statusFilter");
      }

      const queryParams = {
        page,
        count: pageSize,
        type: params.status || "",
        prop: params.prop || "",
        workType: params.workType || "",
        propUnit: params.propUnit || "",
        address: params.address || "",
        city: params.city || "",
        job: params.jobs || "",
        remark: params.remark || "",
        requestBy: params.requestBy || "",
        createBy: params.createByName || "",
        requestNo: params.requestNo || "",
        vendorName: params.vendorName || "",
        sCreateTime: params.sCreateTime || "",
        eCreateTime: params.eCreateTime || "",
        sCompletionDate: params.sCompletionDate || "",

        eCompletionDate: params.eCompletionDate || "",
        requestByName: params.requestByName || "",
        ...(ids ? { ids } : {}),
        groupSupervisor: params.groupSupervisor || "",
        status: params.status || "",
        isMaterials: params.isMaterials || "",
        orderField: params.orderField || "",
        orderType: params.orderType || "",
      };

      // 过滤掉空值参数
      const filteredParams = Object.fromEntries(
        Object.entries(queryParams).filter(([_, v]) => v !== ""),
      );
      const response = await http.get(`${api.MaintenanceShow}`, {
        params: filteredParams,
      });
      if (response.code === "1") {
        const dataWithKey = (response.data.list || [])?.map((item) => ({
          ...item,
          key: item.id,
        }));

        setTableList(dataWithKey);
        setPagination((prev) => ({
          ...prev,
          current: page,
          total: response.data.total,
          pageSize: pageSize,
        }));
      } else {
        // message.error(response.message);
      }
    } catch (err) {
      console.error("Error:", err);
      setError(err);
      message.error("Failed to fetch data");
    } finally {
      // console.log("Loading finished");
      setTableLoading(false);
    }
  };

  // 处理分页变化
  const handleTableChange = (newPagination, filters, sorter) => {
    let orderField = "";
    let orderType = "";

    if (sorter && sorter.field) {
      orderField = fieldMap[sorter.field] || sorter.field; // 用映射表转换
      orderType = sorter.order === "ascend" ? "asc" : "desc";
    }

    getTableListFn(newPagination.current, newPagination.pageSize, {
      ...tableHead,
      orderField,
      orderType,
    });
  };
  //details跳转
  const showModalOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    // const route = "/JobRequests/Maintenance/Details";
    const route = "/JobRequests/Maintenance/Details";
    const paramString = new URLSearchParams(params).toString();
    // console.log(paramString);
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const showOpen = (record) => {
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance/PUTTable";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const loadData = async (
    current = pagination.current,
    pageSize = pagination.pageSize,
  ) => {
    const controller = new AbortController();
    try {
      setTableLoading(true);
      // 获取URL参数
      const fullUrl = new URL(window.location.href);
      const hashParts = fullUrl.hash.split("?");
      let params = {};
      if (hashParts.length > 1) {
        const queryString = hashParts[1];
        const ids = new URLSearchParams(queryString).get("ids");
        if (ids) params = { ids };
      }

      const response = await http.get(`${api.MaintenanceShow}`, {
        params: {
          page: current,
          count: pageSize,
          ...params,
        },
        signal: controller.signal,
      });

      setTableList(
        (response.data.list || []).map((item) => ({ ...item, key: item.id })),
      );
      setPagination((prev) => ({
        ...prev,
        current,
        total: response.data.total,
        pageSize,
      }));
    } catch (err) {
      if (err.name !== "AbortError") {
        setError(err);
      }
    } finally {
      setTableLoading(false);
    }
  };

  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      setColumns((prevColumns) => {
        return prevColumns.map(
          (col) =>
            checkedValues.includes(col.key)
              ? { ...col, hidden: false } // 如果列的 key 在 checkedValues 中，显示该列
              : { ...col, hidden: true }, // 否则隐藏该列
        );
      });
    },
    // input 搜索
    getSearchValues: () => {
      return {
        ...tableHead,
      };
    },
    newListFun: () => {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    },
  }));

  useEffect(() => {
    if (!initialLoad.current) {
      initialLoad.current = true;
      loadData();
      return;
    }
  }, [location.hash]);
  // 分页序号更新
  useEffect(() => {
    const updatedColumns = initColumns.map((col) => {
      if (col.dataIndex === "#") {
        return {
          ...col,
          render: (text, record, index) =>
            (pagination.current - 1) * pagination.pageSize + index + 1,
        };
      }
      return col;
    });

    setColumns(updatedColumns);
  }, [pagination]);

  // 刷新
  useEffect(() => {
    if (isFirstRefresh.current) {
      isFirstRefresh.current = false;
      return;
    }
    const timeoutId = setTimeout(() => {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [refreshKey]);
  // 筛选条件变化
  useEffect(() => {
    props.onFilterChange(tableHead);
  }, [tableHead, props.onFilterChange]);

  return (
    <div>
      <CustomTable
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        setTableHead={setTableHead} // 必需
        getTableListFn={getTableListFn} //
      />
      <Modal
        width="30%"
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <FileTextOutlined style={{ marginRight: "8px" }} />
            Review Materials
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        className="reviewMaterialsModal"
        footer={
          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              onClick={() => setReviewMaterialsModal(false)}
            >
              Close
            </Button>
          </div>
        }
        open={reviewMaterialsModal}
        onCancel={(e) => setReviewMaterialsModal(false)}
      >
        <Spin spinning={reviewMaterialsLoading}>
          <List
            header={null}
            footer={null}
            split={true}
            className="review-materials-list"
            dataSource={reviewMaterialsList}
            renderItem={(item) => (
              <List.Item className="review-materials-item">
                <div className="RM-top">
                  <div className="RM-left">
                    <div>Pick-Up Location:</div>
                    <Input.TextArea
                      autoSize
                      disabled={true}
                      value={item.storeName}
                    />
                    <div>MaterialsRemark:</div>
                    <Input.TextArea
                      autoSize
                      disabled={true}
                      value={item.materialsRemark}
                    />
                  </div>
                  <div className="RM-right">
                    <div className="RM-icon">
                      {item.reviewStatus === 2 && (
                        <CheckOutlined style={{ color: "#18bc37" }} />
                      )}
                      {item.reviewStatus === 3 && (
                        <CloseOutlined style={{ color: "#ff0000" }} />
                      )}
                    </div>
                    <div>
                      {item.reviewStatus === 1 ? (
                        <div className="ApprovalBtn">
                          <div>Waiting For Approval</div>
                          <div className="RM-btn">
                            <Button
                              type="primary"
                              onClick={() => approvalFn(item)}
                            >
                              Approval
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div>{item.reviewByName}</div>
                          <div>{dataTo12Fn(item.reviewTime, 2)}</div>
                          <div>{dataTo12Fn(item.reviewTime, 3)}</div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </Spin>
      </Modal>
      <Modal
        width="30%"
        title="Do You Agree"
        footer={null}
        open={approvalModal}
        onCancel={approvalModalCancel}
      >
        <Radio.Group
          value={approvalState.reviewStatus}
          options={[
            {
              value: "2",
              label: "agree",
            },
            {
              value: "3",
              label: "refuse",
            },
          ]}
          onChange={(e) =>
            setApprovalState({ ...approvalState, reviewStatus: e.target.value })
          }
        />
        {approvalState.reviewStatus === "3" && (
          <div
            style={{ display: "flex", alignItems: "center", marginTop: "12px" }}
          >
            <span>Reason：</span>
            <Input.TextArea
              autoSize
              value={approvalState.rejectReason}
              onChange={(e) =>
                setApprovalState({
                  ...approvalState,
                  rejectReason: e.target.value,
                })
              }
              placeholder="input rejectReason"
            />
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "12px",
          }}
        >
          <Button type="primary" onClick={() => approvalSubmitFn()}>
            Submit
          </Button>
        </div>
      </Modal>
      <Modal
        width="30%"
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            Invoice Job History
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        footer={
          <div style={{ textAlign: "center" }}>
            <Button type="primary" onClick={() => setCloskModal(false)}>
              Close
            </Button>
          </div>
        }
        open={closkModal}
        onCancel={() => setCloskModal(false)}
      >
        <Spin spinning={clockListLoading}>
          <div
            className="IJH-list"
            style={{ minHeight: clockListLoading ? 100 : "auto" }}
          >
            {clockList.length
              ? clockList.map((item) => (
                  <div key={item.id} className="IJH-item">
                    <span>Time: </span>
                    <span className="IJH-time">
                      {dataTo12Fn(item.clockTime)}
                    </span>
                  </div>
                ))
              : !clockListLoading && <div className="IJH-noData">no data</div>}
          </div>
        </Spin>
      </Modal>
    </div>
  );
});
export default MainTable;
